import { ActionBase } from ".";

export class DeleteAction extends ActionBase {

  performAction() {
    for (const obj of this.imageEditor.canvas.getActiveObjects()) {
      this.imageEditor.canvas.remove(obj);
    }
  }

}